import { createRouter, createWebHistory } from "vue-router";
import authService from "@/services/auth.service";

import Applayouts from "../components/layouts/app.layouts";
import Dashboardlayouts from "../components/layouts/dashboard.layouts";
const BASE_TITLE = "Buzón Digital Laboral | Plataforma Confidencial para Reportes Corporativos";
const BASE_DESCRIPTION = "Plataforma de Buzón Digital Laboral para empresas. Sistema confidencial y seguro para reportar conductas inapropiadas, promoviendo integridad, transparencia y cumplimiento normativo en tu organización.";
const BASE_URL = "https://ethics.hr-outservice.com";

const routes = [
  {
    path: "/",
    name: "Home Page",
    component: Applayouts,
    meta: {
      required: false,
    },
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("../pages/Home.page.vue"),
        meta: {
          required: false,
          seo: {
            title: BASE_TITLE,
            description: BASE_DESCRIPTION,
            canonical: `${BASE_URL}/`,
          },
        },
      },

      {
        path: "/avisodeprivacidad",
        name: "AvisoDePrivacidad",
        component: () => import("../pages/AvisoDePrivacidad.page.vue"),
        meta: {
          required: false,
          seo: {
            title: "Aviso de Privacidad | Buzón Digital Laboral",
            description: "Aviso de privacidad de HR Outservice. Conoce cómo tratamos y protegemos tus datos personales conforme a la legislación mexicana.",
            canonical: `${BASE_URL}/avisodeprivacidad`,
          },
        },
      },

      {
        path: "/:company",
        name: "company-list",
        component: () => import("../pages/Register.page.vue"),
        meta: {
          required: false,
        },
      },
      {
        path: "/create-company/:token",
        name: "create-company",
        component: () => import("../pages/admin/Create.page.vue"),
        meta: {
          required: false,
        },
      },
      {
        path: "/login",
        name: "/login",
        component: () => import("../pages/Login.page.vue"),
        meta: {
          required: false,
          seo: {
            title: "Iniciar Sesión | Buzón Digital Laboral",
            description: "Accede a tu cuenta en el Buzón Digital Laboral. Sistema seguro para la gestión de reportes éticos organizacionales.",
            canonical: `${BASE_URL}/login`,
          },
        },
      },
      {
        path: "/recuva",
        name: "/recuva",
        component: () => import("../pages/Recuva.page.vue"),
        meta: {
          required: false,
          seo: {
            title: "Recuperar Contraseña | Buzón Digital Laboral",
            description: "Recupera el acceso a tu cuenta del Buzón Digital Laboral.",
            canonical: `${BASE_URL}/recuva`,
          },
        },
      },
      {
        path: "/password/validate",
        name: "/password",
        component: () => import("../pages/Password.page.vue"),
        meta: {
          required: false,
          seo: {
            title: "Nueva Contraseña | Buzón Digital Laboral",
            description: "Establece tu nueva contraseña para acceder al Buzón Digital Laboral.",
          },
        },
      },

      {
        path: "/:company/login",
        name: "company login",
        component: () => import("../pages/Login.page.vue"),
        meta: {
          required: false,
          seo: {
            title: "Iniciar Sesión | Buzón Digital Laboral",
            description: "Accede al Buzón Digital Laboral de tu organización de forma segura y confidencial.",
          },
        },
      },
      {
        path: "/register",
        name: "register",
        component: () => import("../pages/Register.page.vue"),
        meta: {
          required: false,
        },
      },
      {
        path: "/:company/buzon",
        name: "buzon",
        component: () => import("../pages/Buzon.page.vue"),
        meta: {
          required: false,
        },
      },
      {
        path: "/:company/validate",
        name: "validate",
        component: () => import("../pages/Validate.page.vue"),
        meta: {
          required: false,
        },
      },
      {
        path: "/validate/otp",
        name: "Código de verificación",
        component: () => import("../pages/Otp.vue"),
        meta: {
          required: false,
        },
      },
    ],
  },
  {
    path: "/admin",
    name: "Administador",
    component: Dashboardlayouts,
    meta: {
      required: true,
      roles: ["admin", "superadmin", "manager", "reader"],
    },
    children: [
      {
        path: "/admin",
        name: "Administador dashboard",
        component: () => import("../pages/admin/Index.page.vue"),
      },
      {
        path: "/admin/import/messages",
        name: "ImportMensajes",
        component: () => import("../pages/admin/ImportMessages.page.vue"),
      },
      {
        path: "/admin/messages",
        name: "Mensajes",
        component: () => import("../pages/admin/Messages.page.vue"),
      },
      {
        path: "/admin/create",
        name: "admincreate",
        component: () => import("../pages/admin/Create.page.vue"),
      },
      {
        path: "/admin/configuracion",
        name: "AdminConfig",
        component: () => import("../pages/admin/Configuration.page.vue"),
      },
      {
        path: "/admin/administracion",
        name: "Administation User",
        component: () => import("../pages/admin/AdministrationUser.page.vue"),
        meta: {
          required: true,
          roles: ["admin", "manager"],
        },
      },
      {
        path: "/admin/administracion/area",
        name: "Administation Area",
        meta: {
          required: true,
          roles: ["admin"],
        },
        component: () => import("../pages/admin/AdministrationArea.page.vue"),
      },
      {
        path: "/admin/administracion/report",
        name: "Administation Report",
        meta: {
          required: true,
          roles: ["admin"],
        },
        component: () => import("../pages/admin/AdministrationReport.page.vue"),
      },
      {
        path: "/admin/configuracion/empresas",
        name: "Company Config",
        meta: {
          required: true,
          roles: ["superadmin"],
        },
        component: () => import("../pages/admin/ConfigurationCompany.page.vue"),
      },
      {
        path: "/admin/configuracion/nuevaempresas",
        name: "NewRegisterCompany",
        component: () => import("../pages/admin/Create.page.vue"),
      },
      {
        path: "/admin/configuracion/administradores",
        name: "Módulo de Administradores",
        meta: {
          required: true,
          roles: ["admin"],
        },
        component: () => import("../pages/admin/AdministrationUser.vue"),
      },
      {
        path: "/estadisticos",
        name: "Etadisticos",
        component: () => import("../pages/estadisticos/Estadisticos.page.vue"),
      },
    ],
  },
];

const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach(async (to, from, next) => {
  try {
    const accessToken = localStorage.getItem("accessToken");

    // Si no hay token, verificar si la ruta requiere autenticación
    if (!accessToken) {
      if (to.meta.required) {
        return next({
          name: "/login",
          query: { redirect: to.fullPath },
          replace: true
        });
      }
      return next();
    }

    // Obtener usuario desde el servicio (cache o API)
    const user = await authService.getCurrentUser();

    // Si no hay usuario pero hay token, el token es inválido
    if (!user) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");
      localStorage.removeItem("company");
      localStorage.removeItem("slug");
      authService.clearCache();
      
      if (to.meta.required) {
        return next({
          name: "/login",
          query: { redirect: to.fullPath },
          replace: true
        });
      }
      return next();
    }

    // Si intenta ir a login teniendo sesión activa, redirigir según rol
    if ((to.name === "/login" || to.name === "login" || to.name === "company login") && user) {
      switch (user.rol) {
        case "user":
          return next({
            path: `/${user.company?.slug || ""}/buzon`,
            replace: true
          });
        case "admin":
        case "superadmin":
        case "manager":
        case "reader":
          return next({
            path: "/admin",
            replace: true
          });
        default:
          return next();
      }
    }

    // Si la ruta requiere autenticación
    if (to.meta.required) {
      // Verificar roles si están definidos
      if (to.meta.roles && Array.isArray(to.meta.roles)) {
        const hasRole = to.meta.roles.includes(user.rol);
        
        if (!hasRole) {
          console.warn(`Usuario sin permisos para acceder a ${to.path}. Rol: ${user.rol}, Roles permitidos:`, to.meta.roles);
          return next({
            path: user.rol === "user" ? `/${user.company?.slug || ""}/buzon` : "/admin",
            replace: true
          });
        }
      }
    }

    // Permitir navegación
    next();
  } catch (error) {
    console.error("Error en router guard:", error);
    // En caso de error, limpiar storage y redirigir a home
    authService.clearCache();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");
    localStorage.removeItem("company");
    localStorage.removeItem("slug");
    
    if (to.meta.required) {
      next({ 
        name: "/login",
        query: { redirect: to.fullPath },
        replace: true 
      });
    } else {
      next();
    }
  }
});

router.afterEach((to) => {
  const seo = to.meta?.seo;

  // Actualizar título
  document.title = seo?.title || BASE_TITLE;

  // Actualizar meta description
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute("content", seo?.description || BASE_DESCRIPTION);
  }

  // Actualizar canonical
  let canonical = document.querySelector('link[rel="canonical"]');
  if (seo?.canonical) {
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", seo.canonical);
  }

  // Actualizar Open Graph
  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) ogTitle.setAttribute("content", seo?.title || BASE_TITLE);

  const ogDescription = document.querySelector('meta[property="og:description"]');
  if (ogDescription) ogDescription.setAttribute("content", seo?.description || BASE_DESCRIPTION);

  const ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl && seo?.canonical) ogUrl.setAttribute("content", seo.canonical);

  // Actualizar Twitter Card
  const twitterTitle = document.querySelector('meta[name="twitter:title"]');
  if (twitterTitle) twitterTitle.setAttribute("content", seo?.title || BASE_TITLE);

  const twitterDescription = document.querySelector('meta[name="twitter:description"]');
  if (twitterDescription) twitterDescription.setAttribute("content", seo?.description || BASE_DESCRIPTION);

  const twitterUrl = document.querySelector('meta[name="twitter:url"]');
  if (twitterUrl && seo?.canonical) twitterUrl.setAttribute("content", seo.canonical);
});

export default router;
